import * as React from 'react';
import { storyblokEditable } from 'gatsby-source-storyblok';
import { render, MARK_LINK } from 'storyblok-rich-text-react-renderer';
import clsx from 'clsx';
import { getPlainText } from '@storyofams/storyblok-toolkit';
import LinkResolver from '../../helpers/link-resolver';

export default function BlogPostFAQ(faq) {
  const styles = clsx(
    'blok-blogpost-faq',
  );

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faq?.faq_items?.map((faqItem) => ({
      '@type': 'Question',
      name: faqItem.Question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: getPlainText(faqItem.Answer),
      },
    })),
  };

  return (
    <>
      <div {...storyblokEditable(faq)} className={styles}>
        <h2>{faq?.title}</h2>
        {faq?.faq_items?.map((faqItem, index) => (
          <details key={faqItem._uid} open={index === 0}>
            <summary className="text-2xl font-bold my-4 cursor-pointer marker:text-latori-green">{faqItem.Question}</summary>
            {typeof faqItem.Answer === 'string' ? (
              <p>{faqItem.Answer}</p>
            ) : (
              render(faqItem.Answer, {
                markResolvers: {
                  [MARK_LINK]: LinkResolver,
                },
              })
            )}
          </details>
        ))}
      </div>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
    </>
  );
}
